import { FC } from 'react'
import { Input } from 'src/components/input'

type TextInputFieldVariant = 'light' | 'dark' | 'primary'

type ValidatorRef = { validationType: string; value: Record<string, unknown> }

interface TextInputFieldProps {
  value?: string | null
  disabled?: boolean
  numPad?: boolean
  handleResponse: (value: string) => void
  // Props below exist for interface consistency with other field types
  variant?: TextInputFieldVariant
  handleSearch?: (value: string) => void
  options?: unknown[]
  loading?: boolean
  isMultiple?: boolean
  questionDisplay?: string | null
  valueRef?: unknown
  validatorsRef?: ValidatorRef[]
  patternError?: string | null
  onPatternError?: (error: string | null) => void
}

const TextInputField: FC<TextInputFieldProps> = ({
  handleResponse,
  value,
  numPad = false,
  disabled = false,
  patternError,
}) => {
  const inputValue = value === null || value === undefined ? '' : value

  // Validation and branching are driven by the server; this field only renders
  // the input and any server-provided error passed via `patternError`.
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleResponse(e.target.value)
  }

  return (
    <div>
      <Input
        type={numPad ? 'number' : 'text'}
        pattern={numPad ? '[0-9]*' : ''}
        disabled={disabled}
        value={inputValue}
        onChange={handleChange}
      />
      {patternError && <p className="mt-1 text-sm text-error">{patternError}</p>}
    </div>
  )
}

export default TextInputField
